import React from 'react';
import {
  FDStack, FDEmphasisSurface, FDBox,
} from '@facet-wealth/design';

import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Divider from 'Components/UI/Divider';

import useMobileLayout from 'Hooks/useMobileLayout';

export const Footer = () => {
  const isMobile = useMobileLayout();

  const alignRightItems = isMobile ? 'start' : 'end';

  return (
    <>
      <FDBox paddingY={isMobile ? 2 : 3} />
      <FDEmphasisSurface rounded={false}>
        <FDStack direction={'column'} spacing={2} paddingX={isMobile ? 2 : 4} paddingY={isMobile ? 4 : 8}>
          <FDStack direction={isMobile ? 'column' : 'row'} spacing={3} justifyContent={'space-between'} alignItems={isMobile ? undefined : 'flex-end'}>
            <FDStack direction={'column'} spacing={1}>
              <MetaControlField attr={'influencerFooterGetStartedPhone'} />
              <MetaControlField attr={'influencerFooterMemberQuestionsPhone'} />
            </FDStack>
            <FDStack direction={'column'} spacing={1}>
              <MetaControlField attr={'influencerFooterEmail'} align={alignRightItems} />
              <MetaControlField attr={'influencerFooterMediaInquiries'} align={alignRightItems} />
              <MetaControlField attr={'influencerFooterAddress'} align={alignRightItems} />
              <MetaControlField attr={'influencerFooterCopyright'} align={alignRightItems} />
            </FDStack>
          </FDStack>
          <Divider color={'white'} />
          <div style={isMobile ? {} : { columnCount: 2, columnGap: '48px' }}>
            <MetaControlField attr={'influencerFooterDisclosure'} />
          </div>
        </FDStack>
      </FDEmphasisSurface>
    </>

  );
};
